<div class="settings-page">
  <div class="settings-header">
    <div>
      <h2>Settings</h2>
      <p class="sub-header">Manage users and administration roles</p>
    </div>
  </div>

  <nav class="sub-nav" aria-label="Settings navigation">
    <a routerLink="/settings/company-admin" routerLinkActive="active">Company Admin</a>
    <a routerLink="/settings/shop-admin" routerLinkActive="active">Shop Admin</a>
  </nav>

  <router-outlet></router-outlet>
</div>